:host {
  height: 100%;
  width: 100%;
  // background cover will make the image fill the entire container
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  margin: 0;
  box-sizing: border-box;
  padding: 0;
  position: relative;

  div {
    position: absolute;
    background: linear-gradient(180deg, rgba(2, 0, 36, 0) 0%, rgba(7, 8, 37, 0.9) 50%, rgba(12, 16, 39, 1) 100%);
    color: #fff;
    bottom: 0;
    width: 100%;
    padding: 0.5rem;
    box-sizing: border-box;
    padding: 0 20px;

    h2 {
      margin: 1rem 0 0 0;
      font-size: 20px;
      font-weight: 400;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      margin: 5px 0 10px 0;
    }
  }
}
